module.exports = __webpack_public_path__ + "img/DE.88de003f.svg";